module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "page-breadcrumb"
  }, [_c('li', [_c('i', {
    staticClass: "icon-home",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Home")]), _vm._v(" "), (_vm.pages) ? _c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _vm._l((_vm.pages), function(page, index) {
    return _c('li', [(page.link) ? _c('a', {
      attrs: {
        "href": page.link
      }
    }, [_vm._v(_vm._s(page.text))]) : _vm._e(), _vm._v(" "), (!page.link) ? _c('span', [_vm._v(_vm._s(page.text))]) : _vm._e(), _vm._v(" "), (index !== _vm.pages.length - 1) ? _c('i', {
      staticClass: "fa fa-angle-right",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3291df81","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/components/breadcrumb/breadcrumb.vue
// module id = 1052
// module chunks = 1